import type {ModalProps} from '@yandex-delivery/blocks'
import {Lead, LinkButton, Modal, Slot, Text, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {i18n} from 'src/shared/config'

import * as classes from './classes'

type Props = Pick<ModalProps, 'opened'> & {
  link: string
}

export function WhatsNextModal(props: Props): React.ReactElement<Props> {
  return (
    <Modal
      className={classes.root}
      data-e2e="whats-next-modal"
      onClose={function onClose() {
        window.location.href = props.link
      }}
      opened={props.opened}
    >
      <Modal.Header
        renderTitle={(a11yProps, typographyProps) => (
          <Typography group="tight" id={a11yProps.id} mt="s" thickness="medium" variant="title4">
            {typographyProps.children}
          </Typography>
        )}
        title={i18n('modal.whats-next.title', 'Заказ оформлен! Что дальше')}
      />
      <Modal.Body>
        <div className={classes.slotWrapper}>
          <Slot size="l">
            <Lead>
              <div className={classes.iconSpot}>
                <Typography group="normal" thickness="medium" variant="title4">
                  1
                </Typography>
              </div>
            </Lead>
            <Text>
              <Typography group="tight" pb="xs" thickness="bold" variant="body2">
                {i18n('modal.whats-next.description-one.title', 'Отнесите посылку в пункт')}
              </Typography>
              <Typography group="tight" thickness="regular" variant="caption1">
                {i18n(
                  'modal.whats-next.description-one.subtitle',
                  'Упаковывать не нужно: это сделает сотрудник пункта',
                )}
              </Typography>
            </Text>
          </Slot>
        </div>
        <div className={classes.slotWrapper}>
          <Slot size="l">
            <Lead>
              <div className={classes.iconSpot}>
                <Typography group="normal" thickness="medium" variant="title4">
                  2
                </Typography>
              </div>
            </Lead>
            <Text>
              <Typography group="tight" pb="xs" thickness="bold" variant="body2">
                {i18n(
                  'modal.whats-next.description-two.title',
                  'Отправителю и получателю придёт ссылка на отслеживание',
                )}
              </Typography>
              <Typography group="tight" thickness="regular" variant="caption1">
                {i18n('modal.whats-next.description-two.subtitle', 'Там же будут номер заказа и адреса пунктов')}
              </Typography>
            </Text>
          </Slot>
        </div>
      </Modal.Body>
      <Modal.Footer p="s">
        <LinkButton data-e2e="account-registration" href={props.link} variant="action" fullWidth>
          {i18n('modal.whats-next.button.confirm', 'Понятно')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
}
